import { postRequest } from '../base_requests';

export function requestCompaniesDetails(company_record_ids) {
  return postRequest({ url: `/staff/reports/workload/companies.json`, body: { workload: { company_record_ids }}})
}

export function requestWorkloadCompaniesDetails(company_record_ids) {
  return postRequest({ url: `/staff/reports/workload/workload_companies.json`, body: { workload: { company_record_ids }}})
}